<div class="modal-header">
    <h5 class="modal-title">Assign Project to MYA</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss();"></button>
</div>
<div class="modal-body">
    <form [formGroup]="assignedProjectToMyaForm">
        <div class="mb-3">
            <label for="CLIENT">Client</label>
            <input *ngIf="clientTypeaheadInput" id="CLIENT" type="text" class="form-control" formControlName="client" placeholder="Type to Search" required readonly [ngbTypeahead]="clientTypeaheadInput" (focus)="clientTypeaheadInputFocus$.next($any($event).target.value)" [resultFormatter]="clientResultFormatter" (selectItem)="selectClient($event);">
        </div>
        <div class="mb-3">
            <label for="SITE">Site</label>
            <div class="input-group">
                <select id="SITE" class="form-select" formControlName="site" required readonly>
                    <option *ngFor="let site of sites" [value]="site.id">{{site.address.street}} {{site.address.city}} {{site.address.state}} {{site.address.postalCode}} ({{site.name}})</option>
                </select>
                <button *ngIf="showAddSiteButton" type="button" class="btn btn-primary ms-auto" (click)="openNewSiteModal();" ngbTooltip="New Site">
                    <fa-icon [icon]="faPlus"></fa-icon>
                </button>
            </div>
            <div *ngIf="site.invalid && (site.dirty || site.touched)">
                <div *ngIf="site.errors.required" class="input-validation-msg">Site is required.</div>
            </div>
        </div>
        <div class="mb-3" *ngIf="myaId()">
            <label for="PROJECT_NAME">Project</label>
            <input *ngIf="projectNameTypeaheadInput" #projectNameTypeahead="ngbTypeahead" id="PROJECT_NAME" type="text" class="form-control" placeholder="Lighting" formControlName="projectName" maxlength="150" required [ngbTypeahead]="projectNameTypeaheadInput" (focus)="projectNameTypeaheadInputFocus$.next($any($event).target.value)" [resultFormatter]="projectResultFormatter" [inputFormatter]="projectInputFormatter" (selectItem)="selectProject($event)" [class.is-invalid]="myaId() && projectName.invalid && (projectName.dirty || projectName.touched)">
            <div *ngIf="myaId() && projectName.invalid && (projectName.dirty || projectName.touched)">
                <div *ngIf="myaId() && projectName.errors.required" class="input-validation-msg">Project Name is required.</div>
                <div *ngIf="myaId() && projectName.errors.maxlength" class="input-validation-msg">Project Name cannot exceed 150 characters.</div>
            </div>
        </div>
        <div class="mb-3">
            <label for="PROJECT_PROPOSAL">Proposal</label>
            <select id="PROJECT_PROPOSAL" class="form-select" formControlName="proposal" [class.is-invalid]="myaId() && proposal.invalid && (proposal.dirty || proposal.touched)">
                <option *ngFor="let proposals of projectProposals()" [value]="proposals.proposalId">{{proposals.proposalName}}</option>
            </select>
            <div *ngIf="myaId() && proposal.invalid && (proposal.dirty || proposal.touched)">
                <div *ngIf="myaId() && proposal.errors.required" class="input-validation-msg">Proposal is required.</div>
            </div>
            <div *ngIf="selectedProject && projectName.valid && (projectName.dirty || projectName.touched) && projectProposals().length == 0">
                <div class="input-validation-msg">No MULTI Agreement Type Proposal in this Project</div>
            </div>
        </div>
        <div *ngIf="projectId()">
            <label for="MYA">Multi-Year Agreement</label>
            <select id="MYA" class="form-select" formControlName="mya" required [class.is-invalid]="projectId() && mya.invalid && (mya.dirty || mya.touched)" (change)="selectMultiYearAgreement($event)">
                <option *ngFor="let multiYearAgreement of multiYearAgreements()" [value]="multiYearAgreement.id">{{multiYearAgreement.startYear}}, {{multiYearAgreement.length}} Year(s), {{multiYearAgreement.status | multiYearAgreementStatus }}</option>
            </select>
            <div *ngIf="projectId() && mya.invalid && (mya.dirty || mya.touched)">
                <div *ngIf="projectId() && mya.errors.required" class="input-validation-msg">Multi-Year Agreement is required.</div>
            </div>
        </div>
        <div class="card-body mt-3" *ngIf="projectId() && selectedMya()?.assignedProjects.length > 0">
            <ul class="list-group scrollable">
                <li class="list-group-item" *ngFor="let myaProject of selectedMya()?.assignedProjects">
                    <div class="d-flex">
                        <div>
                            <div class="d-flex">
                                <strong>{{myaProject.projectName }}</strong>
                            </div>
                        </div>
                        <div class="d-flex ms-auto">
                            <strong>{{myaProject.projectYear }}</strong>
                            @switch (myaProject?.status) {
                            @case ("COMPLETED") {
                            <span class="badge text-bg-success my-auto ms-2">Completed</span>
                            }
                            @case ("IN PROGRESS") {
                            <span class="badge text-bg-warning my-auto ms-2">In Progress</span>
                            }
                            @case ("PENDING") {
                            <span class="badge text-bg-warning my-auto ms-2">Pending</span>
                            }
                            @case ("REJECTED") {
                            <span class="badge text-bg-danger my-auto ms-2">Rejected</span>
                            }
                            }
                        </div>
                    </div>
                </li>
                <li *ngIf="selectedMya()?.assignedProjects?.length == 0" class="list-group-item">No Assigned Projects</li>
            </ul>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" [disabled]="assignedProjectToMyaForm.invalid" (click)="addProjectToMya();">Save</button>
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss();">Close</button>
</div>